module.exports = __webpack_public_path__ + "media/images/photo06-66bcdfad8025c9da9ca48dd2039a3c25.png";